import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { Checkbox, Form, Table, TextArea } from 'semantic-ui-react'
import { NonKAApprovmentHistoryDTO } from '../../app/models/models';
import nonKAApproveStore from '../../app/stores/nonKAApproveStore';
import { useStore } from '../../app/stores/store';
import { toJS } from 'mobx';


interface Props {
  accountId: string;
  handleClose: any;
  data: any;
}

export default observer(function HistoryModal(props: Props) {
  const { nonKAApproveStore } = useStore();


  const [historyData, setHistoryData] = useState<NonKAApprovmentHistoryDTO[] | undefined>();




  useEffect(() => {
    const fetchData = async () => {
      await nonKAApproveStore.getNonKAApprovmentHistory(props.accountId);
      if (nonKAApproveStore.nonKAccountHistory) {
        const myhistory = JSON.parse(JSON.stringify(nonKAApproveStore.nonKAccountHistory.nonKAApprovmentHistory))

        setHistoryData(myhistory)
      }
    }
    fetchData()
      .catch(console.error);
  }, [])



  return (

    <div className="HistoryTable">
      <table>
        <thead>
          <tr><th>İşlemi Yapılan Kullanıcı</th>
            <th>İşlem Statüsü</th>
            <th>İşlem Tarihi</th>
          </tr></thead>
        <tbody>
          {historyData?.map(history => (
            <tr key={history.id}>
              <td>{history.modifiedUser}</td>
              {(history.status == "US_NKA_DOCUMENTS_IN_REVIEW") ? <td>Onay Bekliyor</td>
                : (history.status == "US_DENIED") ? <td>Reddedildi</td>
                  : (history.status == "US_NKA_DOCUMENT_REJECTED") ? <td>Döküman Bekliyor</td>
                    : (history.status == "US_TEMPORARY_PASSWORD") ? <td>Giriş Yapılması Bekleniyor</td>
                      : (history.status == "US_READY")? <td>Onaylandı</td>:  <td>{history.status}</td>}



              <td>{history.modifiedAt} </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>



  )

})